import React from "react";
import { BadgeCheck } from "lucide-react";

export function VerifiedBadge({ label = "Verified", className = "", testid = "verified-badge" }) {
  return (
    <span
      data-testid={testid}
      className={`mpn-chip bg-emerald-50 text-emerald-700 border border-emerald-200 ${className}`}
    >
      <BadgeCheck className="w-3.5 h-3.5" />
      {label}
    </span>
  );
}

export function StatusChip({ status }) {
  const map = {
    approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    rejected: "bg-rose-50 text-rose-700 border-rose-200",
    deactivated: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return (
    <span data-testid={`status-${status}`} className={`mpn-chip border ${map[status] || map.pending}`}>
      {status}
    </span>
  );
}
